'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.asBlock = asBlock;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parseProps2 = require('./lib/parse-props');

var _parseProps3 = _interopRequireDefault(_parseProps2);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _propTypes = require('./lib/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var parseProps = (0, _parseProps3['default'])(_config2['default']);

/**
 * UI Block higher-order-component.  This function will return a component that
 * can handle any of the defined style props.  The style props that are accepted
 * are any that are accepted by understyle: https://github.com/jxnblk/understyle/
 *
 * @example
 * function Box(props) {
 *      const { is = 'div', ...rest } = props;
 *      return React.createElement(props.is, rest)
 * }
 *
 * export default asBlock(Box);
 *
 * // later...
 * // style props coverted to the appropriate CSS classes and applied
 * accordingly
 * <Box m2 padding={2}>My Stuff</Box>
 */
function asBlock(BlockComponent) {
    function WithLayout(originalProps) {
        var _parseProps = parseProps(originalProps),
            props = _parseProps.props,
            className = _parseProps.className;

        return _react2['default'].createElement(BlockComponent, _extends({}, props, {
            className: className
        }));
    }

    WithLayout.displayName = 'AsUIBlock(' + (BlockComponent.displayName || BlockComponent.name) + ')';
    WithLayout.propTypes = _propTypes2['default'];

    return WithLayout;
}

exports['default'] = asBlock;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/as-block.jsx
 ** module id = 331
 ** module chunks = 0 1
 **/